export const PRODUCT_GROUPS_TYPE = {
	COLOR: 'color_palette',
	TEXT: 'text',
};
